import React from "react";
import PropTypes from "prop-types";
import "./Input.scss";

function Input(props) {
  const {
    type,
    onChange,
    placeholder,
    name,
    className,
    inputType,
    readOnly,
    ...rest
  } = props;
  const readOnlyCls = readOnly ? "read-only" : "";
  return (
    <input
      type={type}
      className={`input ${className} ${readOnlyCls}`}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
      readOnly={readOnly}
      autoComplete="off"
      {...rest}
    />
  );
}

Input.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
};

Input.defaultProps = {
  className: "",
  onChange: () => {},
  placeholder: "",
  readOnly: false,
};

export default Input;
